import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import languageReducer from './slices/languageSlice';

const PERSIST_KEY = 'ezts_auth';

const persistMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  if (action.type.startsWith('auth/')) {
    const { isAuthenticated, token, user } = store.getState().auth;
    const toPersist = {
      isAuthenticated,
      token,
      user, // <-- persist user object
      lastClosedAt: Date.now(),
    };
    try {
      localStorage.setItem(PERSIST_KEY, JSON.stringify(toPersist));
    } catch {
      // ignore
    }
  }
  return result;
};

const readPersistedAuth = () => {
  try {
    if (typeof window === 'undefined') return undefined;
    const raw = localStorage.getItem(PERSIST_KEY);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw);
    if (
      parsed &&
      typeof parsed === 'object' &&
      'isAuthenticated' in parsed &&
      'lastClosedAt' in parsed &&
      'user' in parsed // <-- require user
    ) {
      // Check if lastClosedAt is recent enough (within 60 minutes)
      const now = Date.now();
      const lastClosedAt = parsed.lastClosedAt;
      if (typeof lastClosedAt === 'number' && now - lastClosedAt < 60 * 60 * 1000) {
        return { auth: parsed };
      } else {
        // Stale session, ignore persisted auth
        return undefined;
      }
    }
  } catch {
    // ignore
  }
  return undefined;
};

const persisted = readPersistedAuth();

export const store = configureStore({
  preloadedState: persisted,
  reducer: {
    auth: authReducer,
    language: languageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(persistMiddleware),
});
